import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Typography,
    Chip
} from "@material-ui/core";

class Audit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    async componentDidMount() {
    }

    render() {

        let { isLoading } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }
        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("audit")} />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container>
                                    <Chip color="primary" style={{ width: '20%' }} label={<Typography variant="h6" gutterBottom component="div">{this.props.t("change_logs")}</Typography>} onClick={() => this.props.history.push("/change-logs")} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>

        </Grid >
    }
}

export default withSnackbar(withTranslation()(Audit))